import React from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';

import CheckingCustomerSignup from '../CheckingCustomerSignup';

const CheckingProspectSignupController: React.FC = () => (
  <Routes>
    <Route index={true} element={<Navigate to="/checking/prospect_signup/identity" />} />
    <Route path="/identity/*" element={<CheckingCustomerSignup variant="prospect" />} />
  </Routes>
);

export default CheckingProspectSignupController;
